import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from '@/utils/request' // axios 不建议引入到 Vue 原型链上
import viewer from '@/viewer'
import './core/use'
import bootstrap from './core/bootstrap'
import '@/permission' // permission control
import '@/utils/filter' // global filter
import vuePlugin from '@/utils/highlight'
import { EventBus } from './event-bus'

Vue.config.productionTip = false

Vue.prototype.$_c = process.env.BASE_URL

Vue.use(VueAxios, router)

//解决v-charts map undefined问题
Vue._watchers = Vue.prototype._watchers = []

Vue.use(viewer)
Vue.use(vuePlugin)

new Vue({
  router,
  store,
  created () {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')
